import classNames from "classnames";
import { useEffect, useState } from "react";

import { Icon } from "src/app/components/icon/Icon";
import ItemQtyCell from "src/app/modules/calculator/components/calculation/components/ItemQtyCell";
import { APPLIANCE_THICKNESS_ITEMS, ProjectSystem, SYSTEM_PARAMETER_TYPE } from "src/app/modules/calculator/types";
import placeholderImg from "src/assets/logos/knauf-logo.png";
import { SystemItemResponse } from "src/core/models/systems";

import calonCss from "./Calculation.module.css";

function Total({ selectedSystems }: { selectedSystems: Array<ProjectSystem> }) {
  const [groupedItemResults, setGroupedItemResults] = useState<Array<any>>();

  function groupProjectSystems(selectedSystems: Array<ProjectSystem>) {
    var result: Array<ProjectSystem> = [];
    selectedSystems.reduce(function (grpResult: any, prSystem: ProjectSystem) {
      if (!grpResult[prSystem.system.id ?? 0]) {
        grpResult[prSystem.system.id ?? 0] = {
          id: prSystem.system.id ?? 0,
          name: prSystem.system.name,
          requiredQuantity: 0,
          requiredApplianceThickness: 0,
          systemItems: prSystem.system.systemItems,
        };
        result.push(grpResult[prSystem.system.id ?? 0]);
      }
      const applianceThickness = prSystem.additionalParameters?.find(
        (x) =>
          x.systemAdditionalParameter?.systemId === prSystem.system.id &&
          x.systemAdditionalParameter?.parameterType === SYSTEM_PARAMETER_TYPE.ApplianceThickness
      );
      grpResult[prSystem.system.id ?? 0].requiredQuantity += prSystem.requiredQuantity;

      if (applianceThickness) {
        grpResult[prSystem.system.id ?? 0].requiredApplianceThickness += applianceThickness.value;
      } else {
        grpResult[prSystem.system.id ?? 0].requiredApplianceThickness += prSystem.requiredApplianceThickness;
      }
      return grpResult;
    }, {});
    return result;
  }

  function calculateSystemItemsQuantities(groupedProjectSystems: Array<any>) {
    var result: Array<SystemItemResponse> = [];
    groupedProjectSystems.forEach((prSys: any) => {
      let reqQty = prSys.requiredQuantity;
      let reqApplianceThickness = prSys.requiredApplianceThickness !== 0 ? prSys.requiredApplianceThickness : 1;
      prSys.systemItems.reduce(function (sysItemResult: any, sysItem: any) {
        if (!sysItemResult[sysItem.id]) {
          sysItemResult[sysItem.id] = {
            id: sysItem.id,
            baseQuantity: APPLIANCE_THICKNESS_ITEMS.includes(sysItem.item.code) ? reqApplianceThickness * sysItem.baseQuantity : sysItem.baseQuantity,
            requiredQuantity: sysItem.baseQuantity * reqQty,
            requiredApplianceThickness: APPLIANCE_THICKNESS_ITEMS.includes(sysItem.item.code) ? reqApplianceThickness : 0,
            item: sysItem.item,
          };
          result.push(sysItemResult[sysItem.id]);
        }
        return sysItemResult;
      }, {});
    });
    return result;
  }

  function groupSystemItems(sysItems: Array<SystemItemResponse>) {
    var result: Array<any> = [];
    sysItems.reduce(function (grpResult: any, sysItem: any) {
      if (!grpResult[sysItem.item.id]) {
        grpResult[sysItem.item.id] = {
          id: sysItem.item.id,
          item: sysItem.item,
          requiredQuantity: 0,
          requiredApplianceThickness: 0,
          baseQuantity: sysItem.baseQuantity,
        };
        result.push(grpResult[sysItem.item.id]);
      }
      const applianceThickness = sysItem.additionalParameters?.find(
        (x: any) =>
          x.systemAdditionalParameter?.systemId === sysItem.id && x.systemAdditionalParameter?.parameterType === SYSTEM_PARAMETER_TYPE.ApplianceThickness
      );

      grpResult[sysItem.item.id].requiredQuantity += sysItem.requiredQuantity;

      if (applianceThickness) {
        grpResult[sysItem.item.id].requiredApplianceThickness += applianceThickness.value;
      } else {
        grpResult[sysItem.item.id].requiredApplianceThickness += sysItem.requiredApplianceThickness;
      }

      return grpResult;
    }, {});
    return result;
  }

  useEffect(() => {
    if (selectedSystems && selectedSystems.length > 0) {
      var projectSysResults: Array<ProjectSystem> = groupProjectSystems(selectedSystems);
      var itemResults: Array<SystemItemResponse> = calculateSystemItemsQuantities(projectSysResults);
      setGroupedItemResults(groupSystemItems(itemResults));
    }
  }, [selectedSystems]);
  return (
    <div>
      {/* Table start */}
      <table className={classNames("u-w100", "u-pt50px", calonCss.productTable)}>
        <thead className="u-col-12">
          <tr>
            <th className="u-pb20px u-col-2 u-t-align-start"></th>
            <th className="u-pb20px u-col-6 u-t-align-start u-t-secondary u-t-uppercase">naziv proizvoda</th>
            {/* <th className="u-pb20px u-col-2 u-t-align-center u-t-secondary u-t-uppercase">potrebna količina</th> */}
            <th className="u-pb20px u-col-2 u-t-align-center u-t-secondary u-t-uppercase">proračunata količina</th>
          </tr>
        </thead>
        <tbody>
          {groupedItemResults &&
            groupedItemResults.length > 0 &&
            groupedItemResults
              .sort((a: any, b: any) => (a.item?.order && b.item?.order && a.item.order < b.item.order ? -1 : 1))
              .map((sysItem: any, index) => <ItemRow key={index} systemItem={sysItem} />)}
        </tbody>
      </table>
      {/* Table end */}
      {/* Mobile HTML */}
      <div className={classNames("u-mt30px", calonCss.mobileSystem)}>
        <div className={classNames("u-col-xs-12", "u-flex", "u-flex-content-center", "u-mb50px", calonCss.listMobile)}>
          <ul className="u-col-xs-12 u-p0">
            {groupedItemResults &&
              groupedItemResults.length > 0 &&
              groupedItemResults
                .sort((a: any, b: any) => (a.item?.order && b.item?.order && a.item.order < b.item.order ? -1 : 1))
                .map((sysItem: any, index) => <ItemListItem key={index} systemItem={sysItem} />)}
          </ul>
        </div>
      </div>
      {/* Mobile end */}
    </div>
  );
}

export default Total;

const ItemRow = ({ systemItem }: { systemItem: any }) => {
  const [active, setActive] = useState(false);
  const item = systemItem.item;
  const itemImageSrc = item?.imagePath != null ? `${process.env.REACT_APP_API_URI}/${item?.imagePath}` : placeholderImg;
  // const baseQty = systemItem && systemItem.baseQuantity != null ? systemItem.baseQuantity : 1;
  const reqQty = systemItem && systemItem.requiredQuantity != null ? systemItem.requiredQuantity : 1;
  const reqApplianceThickness =
    systemItem && systemItem.requiredApplianceThickness != null && systemItem.requiredApplianceThickness !== 0 ? systemItem.requiredApplianceThickness : 1;
  const unitOfMeasurement = item && item?.unitOfMeasurement != null ? item?.unitOfMeasurement : "";

  return !active ? (
    <tr key={item?.id} className="u-col-12">
      <td className={classNames("u-col-2", "u-md-col-3", "u-pos-relative", calonCss.expandCell)}>
        <span
          onClick={() => setActive(!active)}
          className={classNames(
            "u-cursor-pointer",
            "u-bg-secondary-light",
            "u-flex",
            "u-flex-items-center",
            "u-flex-content-center",
            "u-pos-absolute",
            "u-mt10px",
            calonCss.expandBtn
          )}
        >
          <Icon name="plus" className="u-t-primary u-t-f12p" />
        </span>
        <div className={calonCss.itemImageCont}>
          <img className={calonCss.itemImage} alt="prozivod manji" src={itemImageSrc}></img>
        </div>
      </td>
      <td className="u-col-6 u-t-w700 u-t-f16p">{item?.name}</td>
      {/* <ItemQtyCell quantity={baseQty.toFixed(1)} unitOfMeasurement={unitOfMeasurement} expanded={active} mobile={false} isWiderCol={false} /> */}
      <ItemQtyCell
        quantity={((reqQty * reqApplianceThickness * 10) / 10).toFixed(1)}
        unitOfMeasurement={unitOfMeasurement}
        expanded={active}
        mobile={false}
        isWiderCol={false}
      />
    </tr>
  ) : (
    <tr key={item?.id} className="u-col-12">
      <td colSpan={4} className={calonCss.activeCell}>
        <div className={classNames("u-col-12", "u-flex", "u-pos-relative", "u-bt0", calonCss.expandCont)}>
          <span
            onClick={() => setActive(!active)}
            className={classNames(
              "u-cursor-pointer",
              "u-bg-secondary-light",
              "u-flex",
              "u-flex-items-center",
              "u-flex-content-center",
              "u-pos-absolute",
              calonCss.expandBtnLarge
            )}
          >
            <Icon name="plus" className={classNames("u-t-primary u-t-f12p", calonCss.collapseIcon)} />
          </span>
          <div className="u-col-12 u-flex u-flex-column">
            <div className="u-flex u-col-12">
              <div className="u-col-8">
                <div className={classNames("u-ml30px", "u-t-primary", "u-t-w700", "u-t-f18p", calonCss.expandName)}>{item?.name}</div>
              </div>
              {/* <ItemQtyCell quantity={baseQty.toFixed(1)} unitOfMeasurement={unitOfMeasurement} expanded={active} mobile={false} isWiderCol={false} /> */}
              <ItemQtyCell
                quantity={((reqQty * reqApplianceThickness * 10) / 10).toFixed(1)}
                unitOfMeasurement={unitOfMeasurement}
                expanded={active}
                mobile={false}
                isWiderCol={false}
              />
            </div>
            <div className="u-flex u-col-12 u-bg-background">
              <div className={classNames("u-col-3", "u-pl30px", calonCss.expandImgCont)}>
                <img className={calonCss.itemImageLarge} alt="prozivod veći" src={itemImageSrc}></img>
              </div>
              <div className={classNames("u-col-5", calonCss.descriptionCont, calonCss.contBorder)}>
                <h5 className="u-t-f16p u-t-w400 u-t-primary u-mb5px u-mt0 u-t-uppercase">Opis Proizvoda:</h5>
                {item?.descriptions?.map((descr: string) => (
                  <p className="u-t-f16p u-t-w400 u-m0">{descr}</p>
                ))}
              </div>
              <div className={classNames("u-col-2", "u-flex", "u-flex-column", "u-flex-items-start", calonCss.descriptionCont, calonCss.contBorder)}>
                <h5 className="u-t-f16p u-t-w400 u-t-primary u-mb5px u-mt0 u-t-uppercase">Šifra Proizvoda:</h5>
                <p className="u-t-f16p u-t-w400 u-m0 u-mb20px">{item?.code}</p>
                <h5 className="u-t-f16p u-t-w400 u-t-primary u-mb5px u-mt0 u-t-uppercase">Materijal:</h5>
                <p className="u-t-f16p u-t-w400 u-m0">{item?.material}</p>
              </div>
              <div className={classNames("u-col-2", "u-flex", "u-flex-items-end", "u-flex-content-end", calonCss.descriptionCont)}>
                {item?.detailsUrl && (
                  <a href={item.detailsUrl} rel="noreferrer" target="_blank" className="u-t-f16p u-t-w400 u-t-primary u-t-underline u-cursor-pointer">
                    više o proizvodu
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
};

const ItemListItem = ({ systemItem }: { systemItem: any }) => {
  const [active, setActive] = useState(false);

  const item = systemItem.item;
  const itemImageSrc = item?.imagePath != null ? `${process.env.REACT_APP_API_URI}/${item?.imagePath}` : placeholderImg;
  const unitOfMeasurement = item && item?.unitOfMeasurement != null ? item?.unitOfMeasurement : "";
  const reqQty = systemItem && systemItem.requiredQuantity != null ? systemItem.requiredQuantity : 1;
  const reqApplianceThickness =
    systemItem && systemItem.requiredApplianceThickness != null && systemItem.requiredApplianceThickness !== 0 ? systemItem.requiredApplianceThickness : 1;

  return !active ? (
    <li key={item?.id} className="u-pb10px">
      <div className="u-flex u-flex-row u-col-xs-12">
        <span
          onClick={() => setActive(!active)}
          className={classNames(
            "u-cursor-pointer",
            "u-bg-secondary-light",
            "u-flex",
            "u-flex-items-center",
            "u-flex-content-center",
            "u-pos-absolute",
            "u-top0",
            "u-h100",
            calonCss.expandBtn
          )}
        >
          <Icon name="plus" className="u-t-primary u-t-f12p" />
        </span>
        <div className="u-ml30px u-w100">
          <div className="u-flex u-flex-row">
            <img className={calonCss.itemImage} alt="prozivod manji" src={itemImageSrc}></img>
            <div className="u-ml10px">
              <h6 className="u-mt0 u-mb0 u-col-xs-12 u-t-w400 u-t-w400">{item?.name}</h6>
            </div>
          </div>
          <div className="u-w100">
            <table className="u-w100">
              <tbody>
                <tr className="u-t-w700">
                  <td className="u-col-7 u-pl10px u-t-secondary u-t-f16p u-t-lh15 u-t-w400">Proračunata količina:</td>
                  <ItemQtyCell
                    quantity={((reqQty * reqApplianceThickness * 10) / 10).toFixed(1)}
                    unitOfMeasurement={unitOfMeasurement}
                    expanded={active}
                    mobile={true}
                    isWiderCol={true}
                  />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </li>
  ) : (
    <li key={item?.id} className="u-pb10px">
      <div className={classNames("u-col-12", "u-flex", "u-pos-relative", "u-flex-wrap", calonCss.expandCont)}>
        <span
          onClick={() => setActive(!active)}
          className={classNames(
            "u-cursor-pointer",
            "u-bg-secondary-light",
            "u-flex",
            "u-flex-items-center",
            "u-flex-content-center",
            "u-pos-absolute",
            calonCss.expandBtnLarge
          )}
        >
          <Icon name="plus" className={classNames("u-t-primary u-t-f12p", calonCss.collapseIcon)} />
        </span>
        <div className="u-ml30px u-w100">
          <div className="u-flex u-flex-row">
            <img className={calonCss.itemImage} alt="prozivod manji" src={itemImageSrc}></img>
            <div className="u-ml10px">
              <h6 className="u-mt0 u-mb0 u-t-w400 u-col-xs-12">{item?.name}</h6>
            </div>
          </div>
          <div className="u-w100">
            <table className="u-w100">
              <tbody>
                <tr className="u-t-w700">
                  <td className="u-col-7 u-pl10px u-t-secondary u-t-f16p u-t-lh15 u-t-w400">Proračunata količina:</td>
                  <ItemQtyCell
                    quantity={((reqQty * reqApplianceThickness * 10) / 10).toFixed(1)}
                    unitOfMeasurement={unitOfMeasurement}
                    expanded={active}
                    mobile={true}
                    isWiderCol={true}
                  />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="u-col-12 u-ml30px u-flex u-flex-column u-bg-background">
          {item?.descriptions && (
            <div className={classNames("u-wauto", "u-pr10px", "u-mt20px", calonCss.descriptionCont)}>
              <h5 className="u-t-f16p u-t-w400 u-t-primary u-mb5px u-mt0 u-t-uppercase">Opis Proizvoda:</h5>
              {item?.descriptions?.map((descr: string) => (
                <p className="u-t-f16p u-t-w400 u-m0">{descr}</p>
              ))}
            </div>
          )}
          <div className={classNames("u-col-12", "u-flex", "u-flex-column", "u-flex-items-start", calonCss.descriptionCont)}>
            <h5 className="u-t-f16p u-t-w400 u-t-primary u-mb5px u-mt0 u-t-uppercase">Šifra Proizvoda:</h5>
            <p className="u-t-f16p u-t-w400 u-m0 u-mb20px">{item?.code}</p>
            <h5 className="u-t-f16p u-t-w400 u-t-primary u-mb5px u-mt0 u-t-uppercase">Materijal:</h5>
            <p className="u-t-f16p u-t-w400 u-m0">{item?.material}</p>
          </div>
          <div className={classNames("u-col-12", "u-flex", "u-flex-items-end", "u-flex-content-center", "u-ml0", "u-mt10px", "u-mb30px")}>
            {item?.detailsUrl && (
              <a href={item.detailsUrl} rel="noreferrer" target="_blank" className="u-t-f16p u-t-w400 u-t-primary u-t-underline u-cursor-pointer">
                više o proizvodu
              </a>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};
